import AdjustmentDataResult from './AdjustmentDataResult';

export default (props) => {
  return <AdjustmentDataResult {...props} />;
};
